/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import baustein from "baustein";

const filteringClass = "lyst-main--filtering";

const filterPreviewComponentName = "filter-previews";
const quickFiltersComponentName = "quick-filters-card";

export default baustein.register("feed-main", {
    showFilteringOverlay: function() {
        this.el.classList.add(filteringClass);
    },

    hideFilteringOverlay: function() {
        this.el.classList.remove(filteringClass);
    },

    onInsert() {
        this._hideQuickFiltersCategory();
    },

    _hideQuickFiltersCategory() {
        const filterPreviewsComponents = this.findComponents(filterPreviewComponentName);
        const categoryFilterPreviews = filterPreviewsComponents.find(
            component => component.options.previewsType === "category"
        );
        if (categoryFilterPreviews) {
            const quickFiltersComponent = this.findComponent(quickFiltersComponentName);
            if (quickFiltersComponent) {
                quickFiltersComponent.hideNonSelectedCategory();
            }
        }
    }
});

